export default "__VITE_ASSET__f4ef4af1__"